<!-- Input to pick between the different plans -->
<template>
	<div class="mb-1 flex h-14 w-full flex-row items-center justify-start gap-4">
		<div
			v-for="(plan, index) in sessionStore.activePlans"
			:key="index"
			:value="index"
			class="cursor-pointer rounded-md px-3 py-2 text-base"
			data-test-id="selection-cards-tab"
			@click="activePlanIndex = index"
			:class="[
				activePlanIndex === index
					? 'text-primary-700 bg-background-50 font-bold'
					: 'font-normal',
			]"
		>
			{{ `${plan.firstName}${plan.lastName ? ` ${plan.lastName[0]}.` : ''}` }}
		</div>
	</div>
</template>

<script setup lang="ts">
import { useSessionStore } from '@/stores/session'

const activePlanIndex = defineModel<number>()

const sessionStore = useSessionStore()
</script>
